import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { BannerModule } from '../components/banner/banner.module';
import { MatButtonModule } from '@angular/material';

@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    BannerModule,
    MatButtonModule
  ]
})
export class HomeModule { }
